import { useContext } from 'react'
import { useNavigate, useParams } from 'react-router'

import useIsMobile from '../../../utils/hooks/useIsMobile'
import ContactsContext from '../context'
import UserDetailsDrawer from '../user-details-drawer'
import UserDetails from '../user-details-drawer/user-details'

const Contact = () => {
  const { userId, folderId: folderIdParam } = useParams<{ userId: string; folderId: string }>()
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const folderId = Number(folderIdParam)
  const { notificationContacts, doNotContactContacts } = useContext(ContactsContext)
  const allContacts = [...notificationContacts, ...doNotContactContacts]
  const user = allContacts.find((c) => c.user.id === Number(userId))?.user

  if (!user) return null

  if (!isMobile) return <UserDetails user={user} selectedFolderId={folderId} />

  return <UserDetailsDrawer open={true} setOpen={() => navigate(-1)} user={user} selectedFolderId={folderId} />
}

export default Contact
